"use strict";

exports.__esModule = true;
var _ChangeOperatorActionElement = require("./ChangeOperatorActionElement");
Object.keys(_ChangeOperatorActionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChangeOperatorActionElement[key]) return;
  exports[key] = _ChangeOperatorActionElement[key];
});
var _ChangeOperatorDialog = require("./ChangeOperatorDialog");
Object.keys(_ChangeOperatorDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChangeOperatorDialog[key]) return;
  exports[key] = _ChangeOperatorDialog[key];
});
var _ChangeOperatorActionFields = require("./ChangeOperatorActionFields");
Object.keys(_ChangeOperatorActionFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChangeOperatorActionFields[key]) return;
  exports[key] = _ChangeOperatorActionFields[key];
});
var _action = require("./action");
Object.keys(_action).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _action[key]) return;
  exports[key] = _action[key];
});